import type { Theme } from '@material-ui/core';
import { Grid, useMediaQuery } from '@material-ui/core';
import InfoOutlined from '@material-ui/icons/InfoOutlined';
import { Alert } from '@material-ui/lab';
import CustomCopyToClipboard from 'components/CustomCopyToClipboard';
import React, { memo } from 'react';
import { CHECKOUT_ELEMENTS_URL, CHECKOUT_SUN_URL } from 'settings';

interface IProps {
  productId: number | string;
}

const ShareableLinks = ({ productId }: IProps) => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('xs'));
  return (
    <Grid item xs={12}>
      <div className='links-container'>
        <strong>Link para divulgação</strong>

        <Alert icon={<InfoOutlined />} severity='info' className='hash-alert'>
          Seus novos links de Checkout, agora, seguem o padrão de oferta base do MyEduzz. Essa alteração não compromete seus links já criados.
        </Alert>

        {isMobile && (
          <div className='mobile-container'>
            <div>Novo Checkout</div>
            <CustomCopyToClipboard text={`${CHECKOUT_ELEMENTS_URL}/${productId}`} hideInput />
            <div>Antigo Checkout</div>
            <CustomCopyToClipboard text={`${CHECKOUT_SUN_URL}/${productId}`} hideInput />
          </div>
        )}

        {!isMobile && (
          <table>
            <thead>
              <tr>
                <th>Checkout</th>
                <th>Página de pagamento</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Novo</td>
                <td>
                  <CustomCopyToClipboard text={`${CHECKOUT_ELEMENTS_URL}/${productId}`} hideInput />
                </td>
              </tr>
              <tr>
                <td width='160'>Antigo</td>
                <td>
                  <CustomCopyToClipboard text={`${CHECKOUT_SUN_URL}/${productId}`} hideInput />
                </td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
    </Grid>
  );
};

export default memo(ShareableLinks);
